export const WISHLIST_LOAD_START = "Wishlist_Load_Start";
export const WISHLIST_LOAD_END = "Wishlist_Load_End";  
export const WISHLIST_FILTER_CHANGE = "Wishlist_Filter_Change" ;
export const WISHLIST_COURSE_CARD_CLICK = "Wishlist_Course_Card_Click";
export const WISHLIST_COURSE_CARD_WISHLIST_CLICK ="Wishlist_Course_Card_Wishlist_Click";